<template>
	<el-card v-loading="loadingPage" class="box-card">
		<template #header>
			<div class="card-header">
				<span>{{title_product}}</span>
			</div>
		</template>
		<div class="col">
			<el-form label-position="right" label-width="100px" :model="item" ref='form' :rules="rules">
				<el-tabs type="border-card" v-model="headerName" :before-leave='leaveTabEvent' @tab-click="handleTabClick">
					<el-tab-pane label="基础设置" name="0">
						<el-form-item label="商品名称" prop="product_name">
							<el-input v-model="item.product_name" size="small" clearable placeholder="商品名称"></el-input>
						</el-form-item>
						<el-form-item label='商品分类' prop="category_id">
							<div class="block">
								<el-cascader ref="cascader" v-model="item.category_id" :options="options" placeholder="请为商品选择分类" :props="props"
								 @change="handleChange" clearable filterable></el-cascader>
							</div>
						</el-form-item>
						<!-- <el-form-item label="商品价格" prop="product_price">
							<el-input v-model="item.product_price" size='small' style='width: 100px;' placeholder="商品价格"></el-input>
						</el-form-item> -->
						<el-form-item label="商品版号" prop="product_model">
							<el-input v-model="item.product_model" size='small' style='width: 100px;' placeholder="商品版号"></el-input>
						</el-form-item>
						<el-form-item label="商品尺码" prop="product_size_type">
							<el-select filterable v-model="item.product_size_type" clearable placeholder="请选择">
								<el-option v-for="item in all_product_size_type" :key="item.id" :label="item.product_size_name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="商品类型" prop="product_sale_type">
							<el-select filterable v-model="item.product_sale_type" clearable placeholder="请选择">
								<el-option v-for="item in all_product_sale_type" :key="item.id" :label="item.product_sale_name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item label='特殊邮费' prop="product_set_special_shipping">
							<!-- <el-radio-group @change='changeProductShipping' v-model="item.product_special_shipping">
								<el-radio :label="item.value" :key="item.value" v-for="(item,index) in isCreateShipping">{{item.label}}</el-radio>
							</el-radio-group> -->
							<el-select filterable v-model="item.product_set_special_shipping" clearable placeholder="请选择">
								<el-option v-for="item in all_product_postage" :key="item.id" :label="item.template_postage" :value="item.id">
								</el-option>
							</el-select>
							<!-- <el-input-number :disabled="disable_shipping" controls-position="right" :min="0" clearable style='width: 150px;margin-left: 20px;' size="medium" v-model="item.product_set_special_shipping" placeholder="特殊邮费价格" autocomplete="off"></el-input-number> -->
						</el-form-item>
					</el-tab-pane>
					<el-tab-pane label="规格属性" name="1">
						<div v-loading="loadingProductTypeData">
							<el-form-item label="商品模型">
								<el-select @change='changeProductType' @remove-tag='removeProductType' multiple v-model="item.productTypeSelect"
								 filterable clearable placeholder="请选择">
									<el-option v-for="item in productTypeData" :key="item.id" :label="item.product_type_name" :value="item.id"></el-option>
								</el-select>
							</el-form-item>
							<div v-if='this.productSkuSelectList.length>0'>
								<el-form-item style='width: 50%;' label="商品sku">
									<div v-for="(v, i) in productSkuSelectList" :key="i" class="col">
										<b>{{ v.product_type_name }}：</b>
										<el-checkbox-group v-model="checkProductTypeList[i].list" @change="(value) => CheckedSpecChange(value, v,i)">
											<el-checkbox v-for="k in v.type_to_spec" :key="k.id" :label="k.product_spec_name">
												<el-tag effect="plain" type="info" size="medium">{{k.product_spec_name}}</el-tag>
											</el-checkbox>
										</el-checkbox-group>
									</div>
									<el-button size="small" type="primary" @click="productSkuClick">确定</el-button>
									<el-button size="small" type="danger" @click="productSkuClickEmpty">清除</el-button>
								</el-form-item>
								<el-form-item>
									<el-tag v-for="(item, index) in item.productSkuTableList" :key="index" style="margin:10px 10px;">{{ item.model}}</el-tag>
								</el-form-item>
								<el-form-item label="sku列表" prop="productSkuTableList">
									{{item.productSkuTableList.length}}种排列组合
									<div v-if="item.productSkuTableList.length==0">暂无数据</div>
									<el-table v-else :span-method="specSpanMethod" stripe highlight-current-row :data="item.productSkuTableList"
									 border style="width: 100%">
										<el-table-column label="商品规格" align="center">
											<el-table-column label="序号">
												<template #default="scope">
													{{scope.$index+1}}
												</template>
											</el-table-column>
											<el-table-column v-for='(item,index) in skuTypeNameArray' :key='index'>
												<template #header>
													{{item}} --- id:{{skuTypeIdArray[index]}}
												</template>
												<template #default='scope'>
													<span v-if='this.checkProductTypeList[index].list.length>0'>{{scope.row.model[index][item]}}</span>
												</template>
											</el-table-column>
										</el-table-column>
										<el-table-column align="center">
											<template #header>
												<el-tooltip placement="top" content="正数增加，负数减少">
													<i class="header-icon el-icon-info"></i>
												</el-tooltip>
												<span>批量设置: </span>
												<el-popover v-model:visible="specBatchPrice.visible" placement="left-start" :width="200">
													 <el-input-number controls-position="right" :min="0" clearable style='width: 150px;margin-left: 20px;' 
													 size="small" v-model="specBatchPrice.value" placeholder="价格" autocomplete="off"></el-input-number>
													 <div style="text-align: right; margin: 0">
														<el-button size="mini" type="text" @click="specBatchPrice.visible = false">取消</el-button>
														<el-button type="primary" size="mini" @click="batchTableSpecPrice">确定</el-button>
													</div>
													<template #reference>
														<el-button @click="showBatchSpecPrice" type="text" size="small">本店价</el-button>
													</template>
												</el-popover>
												<el-popover v-model:visible="specBatchStock.visible" placement="left-start" :width="200">
													 <el-input-number controls-position="right" :min="0" clearable style='width: 150px;margin-left: 20px;' 
													 size="small" v-model="specBatchStock.value" placeholder="库存" autocomplete="off"></el-input-number>
													 <div style="text-align: right; margin: 0">
														<el-button size="mini" type="text" @click="specBatchStock.visible = false">取消</el-button>
														<el-button type="primary" size="mini" @click="batchTableSpecStock">确定</el-button>
													</div>
													<template #reference>
														<el-button @click="showBatchSpecStock" type="text" size="small">库存</el-button>
													</template>
												</el-popover>
											</template>
											<el-table-column label="价格" prop="price" width="180">
												<template #default="scope">
													<el-form-item required :prop="'productSkuTableList['+scope.$index+'].price'">
														<div>
															<!-- <el-tag v-if="scope.row.snapped_price"  type="success" effect="dark" size='small'>
															秒杀价格:{{scope.row.snapped_price}}
														  </el-tag> -->
															<el-input v-model="scope.row.price" size="small" :placeholder="'请填写价格---'+scope.$index"></el-input>
														</div>
													</el-form-item>
												</template>
											</el-table-column>
											<el-table-column label="库存" prop="stock" width="180">
												<template #default="scope">
													<el-form-item required :prop="'productSkuTableList['+scope.$index+'].stock'">
														<div>
															<!-- <el-tag v-if="scope.row.snapped_price"  type="success" effect="dark" size='small'>
															秒杀价格:{{scope.row.snapped_price}}
														  </el-tag> -->
															<el-input v-model="scope.row.stock" size="small" :placeholder="'请填写库存---'+scope.$index"></el-input>
														</div>
													</el-form-item>
												</template>
											</el-table-column>
										</el-table-column>
									</el-table>
								</el-form-item>
							</div>
							<el-button size="small" type="primary" @click="productSkuClickConfirm">确定</el-button>
						</div>
					</el-tab-pane>
					<el-tab-pane label="图片上传" name="2">
						<el-form-item label="商品缩略图">
							<!-- 单文件上传 -->
							<upload buttonTitle='上传' upload_path='upload_thumb' :resize='750' @success-upload='imgSuccess_SingleFile'></upload>
							<div class="row-no-full" style="flex-wrap: wrap;">
								<div v-for="(v,i) in item.thumb_img" :key='i' style="margin-right: 30px;">
									<div class="col">
										<div class="demo-image__preview">
											<el-image :src='this.getImgPrefix()+v' style='width: 120px;' fit='contain' :preview-src-list="thumbList"></el-image>
										</div>
										<div class="row-no-full" style="justify-content: space-around">
											<upload buttonTitle="更换" upload_path='upload_thumb' type="warning" size="mini" @success-upload='updateThumbImg'
											 :customParams="[i]"></upload>
											<div>
												<el-button type='danger' size='mini' @click='delete_thumb_img(i)'>删除</el-button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</el-form-item>
						<el-form-item label="商品展示图">
							<!-- 多文件上传 more true多选  false单选 -->
							<upload buttonTitle='上传' upload_path='upload_main' :resize='800' :more='true' @success-upload='imgSuccess_MutipleFile'></upload>
							<div class="row-no-full" style="flex-wrap: wrap;">
								<div class="col" v-for="(v,i) in item.main_img" :key='i' style="margin-right: 30px;justify-content:flex-end;">
									<div class="demo-image__preview">
										<el-image :src='this.getImgPrefix()+v' style='width: 120px;' fit='contain' :preview-src-list="mainList"></el-image>
									</div>
									<div class="row-no-full" style="justify-content: space-around">
										<upload buttonTitle="更换" type="warning" upload_path='upload_main' size="mini" @success-upload='updateMainImg'
										 :customParams="[i]"></upload>
										<div>
											<el-button type='danger' size='mini' @click='delete_main_img(i)'>删除</el-button>
										</div>
									</div>
								</div>
							</div>
						</el-form-item>
						<el-form-item label="商品详情图">
							<!-- 多文件上传 more true多选  false单选 -->
							<upload buttonTitle='上传' upload_path='upload_detail' :resize='800' :more='true' @success-upload='imgSuccess_MutipleFileDetail'></upload>
							<div class="row-no-full" style="flex-wrap: wrap;">
								<div class="col" v-for="(v,i) in item.detail_img" :key='i' style="margin-right: 30px;justify-content:flex-end;">
									<div class="demo-image__preview">
										<el-image :src='this.getImgPrefix()+v' style='width: 120px;' fit='contain' :preview-src-list="detailList"></el-image>
									</div>
									<div class="row-no-full" style="justify-content: space-around">
										<upload buttonTitle="更换" type="warning" upload_path='upload_detail' size="mini" @success-upload='updateDetailImg'
										 :customParams="[i]"></upload>
										<div>
											<el-button type='danger' size='mini' @click='delete_detail_img(i)'>删除</el-button>
										</div>
									</div>
								</div>
							</div>
						</el-form-item>
					</el-tab-pane>
					<el-tab-pane label="视频上传" name="3">
						<el-form-item label="视频上传">
							<upload-plus buttonTitle='上传视频' upload_path='upload_product_video' @success-plus='bigFile' :auto_close="true"></upload-plus>
							<div class="row-no-full" style="flex-wrap: wrap;">
								<div v-for="(v,i) in item.product_video" :key='i' style="margin-right: 30px;">
									<div class="col">
										<div class="demo-image__preview">
											<video v-if="item.product_video.length>0" width="320" height="240" controls>
												<source :src="this.getImgPrefix()+v" type="video/mp4">
												您的浏览器不支持 video 标签。
											</video>
										</div>
										<div class="row-no-full" style="justify-content: space-around">
											 <upload-plus buttonTitle='更换' upload_path='upload_product_video' 
											 type="warning" size="mini" @success-plus='updateBigFile' :auto_close="true" :customParams="[i]"></upload-plus>
											<div>
												<el-button type='danger' size='mini' @click='delete_product_video(i)'>删除</el-button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</el-form-item>
					</el-tab-pane>
					<el-tab-pane label="商品详情" name="4">
						<el-form-item label="关键词" prop="product_keywords">
							<el-input v-model="item.product_keywords" size="small" placeholder="可输入商品关键词，有利于SEO搜索" clearable></el-input>
						</el-form-item>
						<el-form-item label="页面描述" prop="product_description">
							<el-input v-model="item.product_description" size="small" placeholder="可输入商品简单描述，有利于SEO搜索" clearable></el-input>
						</el-form-item>
						<el-form-item label="详情描述" prop="product_content">
							<ueditor ref='ue' v-model="item.product_content" :config="myconfig_ueditor"></ueditor>
						</el-form-item>
						<el-button v-if="item.id" size="small" type="primary" @click="product_update_click">修改</el-button>
						<el-button v-else size="small" type="primary" @click="product_add_click">新增</el-button>
					</el-tab-pane>
					
				</el-tabs>
			</el-form>
		</div>
	</el-card>
</template>

<script>
	import Upload from '../common/Upload.vue'
	import Ueditor from '../common/Ueditor.vue'
	import UploadPlus from '../common/UploadPlus.vue'
	export default {
		name: 'ProductEdit',
		components: {
			Upload,
			Ueditor,
			UploadPlus,
		},
		data() {
			return {
				title_product: '新增商品',
				myconfig_ueditor: {
					UEDITOR_HOME_URL: '/UEditor/',
					serverUrl: this.getEnv('host') + '/admin/ueditor/ueditor',
					autoHeightEnabled: false,
					initialFrameHeight: 400,
					initialFrameWidth: 1200,
					toolbars: [
						['source', '|', 'undo', 'redo', '|', 'bold', 'italic',
							'underline', 'strikethrough', '|', 'superscript', 'subscript', '|',
							'forecolor', 'backcolor', '|', 'removeformat', '|',
							'insertorderedlist', 'insertunorderedlist', '|', 'selectall',
							'cleardoc', 'paragraph', '|', 'fontfamily', 'fontsize',
							'|', 'justifyleft', 'justifycenter', 'justifyright', 'justifyjustify',
							'|', 'link', 'unlink', '|', 'emotion', 'simpleupload', 'insertimage',
							'video', '|', 'map', '|', 'horizontal', 'print', 'preview',
							'fullscreen', 'drafts', 'formula'
						]
					] //需要展示的按钮
				},
				headerName: '0',
				props: {
					value: 'id',
					label: 'name',
					children: 'son'
				},
				loadingPage: false,
				loadingProductTypeData: true,
				// isCreateShipping: [
				// 	{ label: "普通邮费", value: 1 },
				// 	{ label: "特殊邮费", value: 2 }
				// ],
				disable_shipping:true,
				options: [],
				thumbList: [],
				mainList: [],
				detailList: [],
				productTypeData: [],
				productSkuSelectList: [],
				checkProductTypeList: [],
				skuSpecIdArray: [],
				skuTypeIdArray: [],
				skuSpecNameArray: [],
				skuTypeNameArray: [],
				all_product_size_type: [],
				all_product_sale_type: [],
				all_product_postage: [],
				specBatchPrice: {    //批量设置价格  弹出层
					// type: '',
					value: 0,
					visible: false
				},
				specBatchStock: {  //批量设置库存 弹出层
					value: 0,
					visible: false
				},
				item: {
					id: '',
					product_name: '',
					category_id: [],
					// product_price: '',
					product_model: '',
					product_size_type: '',
					product_sale_type: '',
					product_special_shipping: '2',
					product_set_special_shipping: '', // 用特殊邮费代替欧美邮费
					product_keywords: '',
					product_description: '',
					product_content: '',
					thumb_img: [],
					main_img: [],
					detail_img: [],
					product_video: [],
					productTypeSelect: [],
					productSkuTableList: [],
					productSkuList: [],
					productSkuIdList: [],
				},
				rules: {
					product_name: [{
						required: true,
						message: '商品名称不能为空',
						trigger: 'blur'
					}],
					category_id: [{
						required: true,
						message: '分类不能为空',
						trigger: 'change'
					}],
					// product_price: [{
					// 	required: true,
					// 	message: '商品价格不能为空',
					// 	trigger: 'blur'
					// }],
					product_model: [{
						required: true,
						message: '商品版号不能为空',
						trigger: 'blur'
					}],
					product_size_type: [{
						required: true,
						message: '商品尺码不能为空',
						trigger: 'change'
					}],
					product_sale_type: [{
						required: true,
						message: '商品类型不能为空',
						trigger: 'change'
					}],
				}
			}
		},
		methods: {
			batchTableSpecPrice(){
				//输入批量价格 后 修改 productSkuTableList 的 价格 
				console.log(this.specBatchPrice.value)
				console.log(this.item.productSkuTableList)
				
				for(let i in this.item.productSkuTableList){
					this.item.productSkuTableList[i]['price']=this.towNumber(this.specBatchPrice.value)
				}
				this.specBatchPrice.visible = false
			},
			batchTableSpecStock(){
				//输入 批量库存 后 修改 productSkuTableList 的  库存
				console.log(this.specBatchStock.value)
				console.log(this.item.productSkuTableList)
				
				for(let i in this.item.productSkuTableList){
					this.item.productSkuTableList[i]['stock']=this.towNumber(this.specBatchStock.value)
				}
				this.specBatchStock.visible = false
			},
			showBatchSpecPrice() {
				//弹出 批量修改 价格 的 小框
				this.specBatchPrice.value = 0
				this.specBatchPrice.visible = true
			},
			showBatchSpecStock(){
				//弹出 批量修改 库存 的 小框
				this.specBatchStock.value = 0
				this.specBatchStock.visible = true
			},
			// changeProductShipping(val){
			// 	console.log(val)
			// 	if(val == 2){
			// 		//选中的是特殊邮费
			// 		this.disable_shipping = false
			// 	}else{
			// 		this.disable_shipping = true
			// 		this.item.product_set_special_shipping = 0
			// 	}
			// },
			product_update_click() {
				//修改商品
				console.log(this.item)
				console.log(this.$refs.ue.getUEContent())
				this.item.product_content = this.$refs.ue.getUEContent();
				this.$refs['form'].validate((valid) => {
					if (valid) {
						this.httpPost({
							url: '/admin/product/productUpdate',
							data: this.item
						}).then((re) => {
							// console.log(re);
							if (re.code > 1) return this.alertWarn('错误')
							this.alertSuccess('成功')
							this.$router.push('/main/product_list');
							// this.$router.go(-1)
						}).catch((err) => {
							this.alertWarn('失败')
						})
					} else {
						this.alertWarn('失败')
						console.log('error submit!!');
						return false;
					}
				})
			},
			product_add_click() {
				//添加商品
				console.log(this.item)
				console.log(this.$refs.ue.getUEContent())
				this.item.product_content = this.$refs.ue.getUEContent();
				this.$refs['form'].validate((valid) => {
					if (valid) {
						this.httpPost({
							url: '/admin/product/productSave',
							data: this.item
						}).then((re) => {
							// console.log(re);
							if (re.code > 1) return this.alertWarn('错误')
							this.alertSuccess('成功')
							this.$router.push('/main/product_list');
						}).catch((err) => {
							this.alertWarn('失败')
						})
					} else {
						this.alertWarn('失败')
						console.log('error submit!!');
						return false;
					}
				})

				// this.$refs.ue.getUEContent();     
			},
			productSkuClickConfirm() {
				console.log(this.item.productSkuTableList)
			},
			CheckedSpecChange(value, v, index) {
				// console.log(value)
				// console.log(v)
				// console.log(index)
				this.checkProductTypeList[index].list_spec_id = []
				let product_spec_array = v.type_to_spec
				for (let i in value) {
					for (let ii in product_spec_array) {
						if (value[i] == product_spec_array[ii].product_spec_name) {
							this.checkProductTypeList[index].list_spec_id.push(product_spec_array[ii].id)
						}
					}
				}
				console.log(this.checkProductTypeList)
			},
			towNumber(value) {
				//保留俩位小数
				return value.toFixed(2)
			},
			clickOtherProductSku(value, index) {
				console.log(value)
				console.log(index)
				// this.item.productSkuList[index].push('111元')
				// console.log(this.item.productSkuList)

			},
			specSpanMethod({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				// console.log(row)
				// console.log('zy')
				// console.log(column)
				// console.log('zy')
				// console.log(rowIndex)
				// console.log('zy')
				// console.log(columnIndex)
				// console.log('zy')
			},
			removeProductType(value) {
				//移除 商品模型 某一项  一次只能执行一次
				// console.log(value)
				// console.log(this.checkProductTypeList)
				this.productSkuClick() // 重新 执行  productSkuClick
			},
			changeProductType(value) {
				// console.log(value)
				// console.log(this.productTypeData)
				// 先清空数据，保证连续点击按钮，数据不会重复
				this.productSkuSelectList = []
				this.checkProductTypeList = []
				this.skuSpecNameArray = []
				this.skuTypeNameArray = []

				this.skuTypeIdArray = []
				this.skuSpecIdArray = []
				this.item.productSkuList = []
				this.item.productSkuTableList = []
				this.item.productSkuIdList = []

				let tmp = this.cloneObj(this.productTypeData)
				for (let i in value) {
					for (let ii in tmp) {
						if (value[i] == tmp[ii].id) {
							this.productSkuSelectList.push(tmp[ii]) // 判断 select框 选中id  和    productTypeData下id 是否有相同; 如果有,就直接赋值给 productSkuSelectList

							let obj = {
								id: tmp[ii].id,
								name: tmp[ii].product_type_name,
								list: [],
								list_spec_id: []
							}
							this.checkProductTypeList.push(obj)

						}
					}
				}
				// console.log(this.checkProductTypeList)
				// console.log(this.productSkuSelectList)
				// console.log(this.item.productTypeSelect)
			},
			productSkuClickEmpty() {
				// console.log(this.checkProductTypeList)
				for (let i in this.checkProductTypeList) {
					this.checkProductTypeList[i].list = []
					this.checkProductTypeList[i].list_spec_id = []
				}
				this.skuTypeNameArray = []

				this.item.productSkuList = []
				this.item.productSkuTableList = []
				this.item.productSkuIdList = []
			},
			productSkuClick() {
				// 先清空数据，保证连续点击按钮，数据不会重复
				this.skuSpecNameArray = []
				this.skuTypeNameArray = []

				this.skuTypeIdArray = []
				this.skuSpecIdArray = []

				this.item.productSkuList = []
				this.item.productSkuTableList = []
				this.item.productSkuIdList = []

				// console.log(this.productTypeData)
				// console.log(this.checkProductTypeList)

				// 将选中的规格组合成一个大数组 [[1, 2], [a, b]...]
				this.checkProductTypeList.forEach(element => {
					// console.log(element)

					element.list.length > 0 ? this.skuSpecNameArray.push(element.list) : ''
					element.list.length > 0 ? this.skuTypeNameArray.push(element.name) : ''
					element.list.length > 0 ? this.skuTypeIdArray.push(element.id) : ''
					element.list.length > 0 ? this.skuSpecIdArray.push(element.list_spec_id) : ''
				})
				// console.log(this.skuSpecNameArray)
				// console.log(this.skuTypeIdArray)
				// console.log(this.skuSpecIdArray)

				// 勾选了规格，才调用方法
				if (this.skuSpecNameArray.length > 0) {
					this.getSkuData([], 0, this.skuSpecNameArray)
					// this.getSkuIdData([], 0, this.skuSpecIdArray)
					this.getSkuIdData([], 0, this.skuSpecIdArray)

					// console.log(this.skuTypeNameArray)
					// console.log(this.item.productSkuList)
					// console.log(this.item.productSkuIdList)

					// console.log(this.skuSpecNameArray)
					// this.addPriceAndstockToProductSkuList(this.item.productSkuList)  // 动态添加 价格 , 库存 初始值
					// console.log(this.item.productSkuList)
					let tmp = this.cloneObj(this.item.productSkuList) // 带 sku 名字的数组
					let tmp1 = this.cloneObj(this.item.productSkuIdList) // 带 sku id 的数组

					for (let i in tmp) {
						let obj = {}
						obj['model'] = tmp[i]
						obj['model_id'] = tmp1[i]
						obj['price'] = this.towNumber(0)
						obj['stock'] = this.towNumber(0)
						this.item.productSkuTableList.push(obj)
					}
					// console.log(this.item.productSkuTableList)

				} else {
					this.$message.error('请先勾选商品sku')
				}
				// console.log(this.skuTypeNameArray)
				// console.log(this.item.productSkuList)

			},
			// 递归获取每条SKU   Id 数据
			getSkuIdData(skuArr = [], i, list) {
				for (let j = 0; j < list[i].length; j++) {
					if (i < list.length - 1) {
						let obj = {}
						obj[this.skuTypeIdArray[i]] = list[i][j]
						skuArr[i] = obj
						this.getSkuIdData(skuArr, i + 1, list) // 递归循环
					} else {
						let obj = {}
						obj[this.skuTypeIdArray[i]] = list[i][j]
						this.item.productSkuIdList.push([...skuArr, obj]) // 扩展运算符，连接两个数组
					}
				}
			},
			// 递归获取每条SKU数据
			getSkuData(skuArr = [], i, list) {
				for (let j = 0; j < list[i].length; j++) {
					if (i < list.length - 1) {
						let obj = {}
						obj[this.skuTypeNameArray[i]] = list[i][j]
						skuArr[i] = obj
						this.getSkuData(skuArr, i + 1, list) // 递归循环
					} else {
						let obj = {}
						obj[this.skuTypeNameArray[i]] = list[i][j]
						this.item.productSkuList.push([...skuArr, obj]) // 扩展运算符，连接两个数组
					}
				}
			},
			handleChange(value) {
				console.log(value);
			},
			leaveTabEvent(activeName, oldActiveName) {
				// return new Promise((resolve, reject) => {
				// 	this.$refs['form'].validate((valid) => {
				// 		if (!valid) {
				// 			this.$message.error('必填项未写!!!')
				// 			console.log('error submit!!');
				// 			reject(oldActiveName);
				// 			return false;
				// 		} else {
				// 			resolve(activeName);
				// 			return true;
				// 		}
				// 	})
				// })
			},
			handleTabClick(tab, event) {
				// console.log(tab, event);
			},
			getCateGoryAll() {
				this.httpPost({
					url: '/admin/category/categoryList',
				}).then((re) => {
					let data = re.data
					// console.log(data)
					let temp = this.cloneObj(data)
					this.options = temp
				}).catch((err) => {


				})
			},
			delete_product_video(index){
				//删除储存在服务器里的  视频
				let productVideoPath = this.item.product_video[index]
				console.log(productVideoPath)
				// return false
				if (productVideoPath) {
					this.msgBoxAjax('警告', '确定删除吗?删除后服务器视频路径也将删除', '/admin/upload/uploadForBigFileDelete', {
						productVideoPath: productVideoPath
					}).then((re) => {
						if (re.code > 1) return this.$message.error(re.msg)
						
						this.item.product_video.splice(index, 1)
					})
				} else {
					this.alertWarn('参数错误');
				}
			},
			delete_thumb_img(index) {
				console.log(index)
				//删除储存在服务器里的  缩略图 图片
				let imgThumbPath = this.item.thumb_img[index]
				console.log(imgThumbPath)
				// return false
				if (imgThumbPath) {
					this.msgBoxAjax('警告', '确定删除吗?删除后服务器图片路径也将删除', '/admin/upload/uploadThumbDelete', {
						imgThumbPath: imgThumbPath
					}).then((re) => {
						if (re.code > 1) return this.$message.error(re.msg)
						if (this.thumbList.length > 0) {
							this.thumbList.splice(index, 1)
						}
						this.item.thumb_img.splice(index, 1)
					})
				} else {
					this.alertWarn('参数错误');
				}

				// this.item.thumb_img.splice(index,1)
			},
			delete_main_img(index) {
				//删除储存在服务器里的  展示图 图片
				let imgMainPath = this.item.main_img[index]
				// console.log(imgMainPath)
				// return false
				if (imgMainPath) {
					this.msgBoxAjax('警告', '确定删除吗?删除后服务器图片路径也将删除', '/admin/upload/uploadMainDelete', {
						imgMainPath: imgMainPath
					}).then((re) => {
						if (re.code > 1) return this.$message.error(re.msg)
						if (this.mainList.length > 0) {
							this.mainList.splice(index, 1)
						}
						this.item.main_img.splice(index, 1)
					})
				} else {
					this.alertWarn('参数错误');
				}
			},
			delete_detail_img(index) {
				//删除储存在服务器里的  详情图 图片
				let imgDetailPath = this.item.detail_img[index]
				// console.log(imgdetailPath)
				// return false
				if (imgDetailPath) {
					this.msgBoxAjax('警告', '确定删除吗?删除后服务器图片路径也将删除', '/admin/upload/uploadDetailDelete', {
						imgDetailPath: imgDetailPath
					}).then((re) => {
						if (re.code > 1) return this.$message.error(re.msg)
						if (this.detailList.length > 0) {
							this.detailList.splice(index, 1)
						}
						this.item.detail_img.splice(index, 1)
					})
				} else {
					this.alertWarn('参数错误');
				}
			},
			updateBigFile(e, params){
				//更换 视频
				console.log(e,params)
				let productVideoOldPath = this.item.product_video[params[0]] //更改之前的  视频路径
				this.httpPost({
					url: '/admin/upload/uploadForBigFileUpdate',
					data: {
						productVideoOldPath: productVideoOldPath,
					}
				}).then((re) => {
					// console.log(re)
					if (re.code > 1) return this.$message.error(re.msg)
					this.item.product_video.splice(params[0], 1) //点击 更换按钮后 重新给 product_video 赋值

					this.$nextTick(() => {
						this.item.product_video.push(e);
					})
				})
			},
			updateThumbImg(e, params) {
				//更换缩略图 图片
				// console.log(e)
				// console.log(params)
				let imgThumbOldPath = this.item.thumb_img[params[0]] //更改之前的图片路径
				this.httpPost({
					url: '/admin/upload/uploadThumbUpdate',
					data: {
						imgThumbOldPath: imgThumbOldPath,
					}
				}).then((re) => {
					// console.log(re)
					if (re.code > 1) return this.$message.error(re.msg)
					if (this.thumbList.length > 0) {
						this.thumbList.splice(params[0], 1, this.getImgPrefix() + e) //缩略图 展示大图 每次删掉前一次的  只保留一张图片
					}
					this.item.thumb_img.splice(params[0], 1, e) //点击 更换按钮后 重新给 thumb_img 赋值
				})


			},
			updateMainImg(e, params) {
				//更换展示图 图片
				// console.log(e)
				// console.log(params)
				let imgMainOldPath = this.item.main_img[params[0]] //更改之前的图片路径
				// console.log(imgMainOldPath)
				this.httpPost({
					url: '/admin/upload/uploadMainUpdate',
					data: {
						imgMainOldPath: imgMainOldPath,
					}
				}).then((re) => {
					if (re.code > 1) return this.$message.error(re.msg)
					if (this.mainList.length > 0) {
						this.mainList.splice(params[0], 1, this.getImgPrefix() + e) //展示图 展示大图 每次删掉前一次的  只保留一张图片
					}
					this.item.main_img.splice(params[0], 1, e) //点击 更换按钮后 重新给 main_img 赋值
				})

			},
			updateDetailImg(e, params) {
				//更换详情页 图片
				// console.log(e)
				// console.log(params)
				let imgDetailOldPath = this.item.detail_img[params[0]] //更改之前的图片路径
				// console.log(imgDetailOldPath)
				this.httpPost({
					url: '/admin/upload/uploadDetailUpdate',
					data: {
						imgDetailOldPath: imgDetailOldPath,
					}
				}).then((re) => {
					if (re.code > 1) return this.$message.error(re.msg)
					if (this.detailList.length > 0) {
						this.detailList.splice(params[0], 1, this.getImgPrefix() + e) //详情页 展示大图 每次删掉前一次的  只保留一张图片
					}
					this.item.detail_img.splice(params[0], 1, e) //点击 更换按钮后 重新给 detail_img 赋值
				})
			
			},
			imgSuccess_MutipleFile(e) {
				// 上传多文件 展示图
				console.log(e);
				for (let i in e) {
					this.mainList.push(this.getImgPrefix() + e[i])
					this.item.main_img.push(e[i])
				}

			},
			imgSuccess_MutipleFileDetail(e) {
				// 上传多文件  详情图
				console.log(e);
				for (let i in e) {
					this.detailList.push(this.getImgPrefix() + e[i])
					this.item.detail_img.push(e[i])
				}
			},
			imgSuccess_SingleFile(e) {
				// 上传单文件
				// console.log(e);
				// console.log(this.thumbList)
				if (this.item.thumb_img.length > 0) {
					this.item.thumb_img.splice(0, 1) //缩略图 每次删掉前一次上传的
				}
				if (this.thumbList.length > 0) {
					this.thumbList.splice(0, 1) //缩略图 展示大图 每次删掉前一次的  只保留一张图片
				}
				this.thumbList.push(this.getImgPrefix() + e)
				this.item.thumb_img.push(e)
			},
			bigFile(file){
				//大文件上传 视频
				console.log(file)  //upload_product_video/20211117/6194639ace1c7.wmv
				if (this.item.product_video.length > 0) {
					this.item.product_video.splice(0, 1) //视频 每次删掉前一次上传的
				}
				this.$nextTick(() => {
					this.item.product_video.push(file);
				})
			},
			getProductType() {
				// typeData
				this.httpPost({
					url: '/admin/product/productTypeList'
				}).then((re) => {
					let data = re.data
					// console.log(data)
					let temp = this.cloneObj(data);
					this.productTypeData = temp;
					this.loadingProductTypeData = false

				}).catch((err) => {})
			},
			getProductSize() {
				this.httpPost({
					url: '/admin/product/productSizeList'
				}).then((re) => {
					let data = re.data
					// console.log(data)
					let temp = this.cloneObj(data);
					this.all_product_size_type = temp;

				}).catch((err) => {})
			},
			getProductSaleType() {
				this.httpPost({
					url: '/admin/product/productSaleTypeList'
				}).then((re) => {
					let data = re.data
					// console.log(data)
					let temp = this.cloneObj(data);
					this.all_product_sale_type = temp;

				}).catch((err) => {})
			},
			getProductPostage() {
				this.httpPost({
					url: '/admin/product/productPostageList'
				}).then((re) => {
					let data = re.data
					// console.log(data)
					let temp = this.cloneObj(data);
					this.all_product_postage = temp;
				}).catch((err) => {})
			},
			getProductDetail() {
				this.loadingPage = true
				console.log(this.item.id)
				this.title_product = '编辑商品'
				this.httpPost({
					url: '/admin/product/productDetail',
					data: {
						id: this.item.id
					}
				}).then((re) => {
					let data = re.data
					// console.log(data)
					let temp = this.cloneObj(data);
					this.item = temp
					console.log(temp)
					//当 特殊邮费 选中的是 特殊邮费 禁用关闭
					// if(this.item.product_special_shipping==2){
					// 	this.disable_shipping = false
					// }
					// this.loadingProductTypeData = false

					this.item.productTypeSelect = []
					for (let i in temp.checkProductTypeList) {
						// console.log(temp.checkProductTypeList[i].id)
						this.item.productTypeSelect.push(temp.checkProductTypeList[i].id)
					}
					this.changeProductType(this.item.productTypeSelect)
					this.$nextTick(() => {
						this.checkProductTypeList = temp.checkProductTypeList
						this.productSkuClick();
						let tempPriceAndStock = temp.productPriceAndStockList
						for (let i in this.item.productSkuTableList) {
							this.item.productSkuTableList[i].id = tempPriceAndStock[i].id
							this.item.productSkuTableList[i].price = tempPriceAndStock[i].price
							this.item.productSkuTableList[i].stock = tempPriceAndStock[i].stock
						}
						this.item.main_img = temp.image_main
						this.item.detail_img = temp.image_detail
						this.item.thumb_img = temp.image_thumb
						this.item.product_video = temp.product_video
						
						for (let i in temp.image_main) {
							this.mainList.push(this.getImgPrefix() +  temp.image_main[i])
						}
						// this.mainList = temp.image_main

						for (let i in temp.image_detail) {
							this.detailList.push(this.getImgPrefix() +  temp.image_detail[i])
						}
						
						for(let i in temp.image_thumb){
							this.thumbList.push(this.getImgPrefix() + temp.image_thumb[i])
						}
						
						// this.item.product_special_shipping = temp.product_special_shipping
						
						this.$refs.ue.setText(temp.product_content); //回显 富文本内容
						this.loadingPage = false
						console.log(this.item.productSkuTableList)
					})

				}).catch((err) => {})
			},

		},
		created() {
			// this.item.product_special_shipping = 1
			this.getCateGoryAll();
			this.getProductType();
			this.getProductSize();
			this.getProductSaleType();
			this.getProductPostage();
			this.item.id = this.$route.query.id;
			if (this.item.id) this.getProductDetail();
		}
	}
</script>

<style>
	.el-tag--plain.el-tag--info {
		/* color: red; */
	}
</style>
